import { fromAddress, geocode, RequestType, setKey } from "react-geocode";

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          console.log("///////////Current Location Lat, Long/////////////");
          console.log(latitude, longitude);
          resolve({ lat: latitude, lng: longitude });
        },
        (err) => {
          console.error("Error getting location:", err);
          alert(err.message);
          reject(err);
        }
      );
    } else {
      const error = new Error("Geolocation is not supported by this browser.");
      alert(error.message);
      reject(error);
    }
  });
};

export const getAddress = async (latitude, longitude) => {
  setKey("AIzaSyDorJcVM6WPoi1QjXo4EFW5Oqft-MlMfvo");

  try {
    const { results } = await geocode(
      RequestType.LATLNG,
      `${latitude}, ${longitude}`
    );
    console.log("///////////Address from Lat Lng/////////////");
    console.log(results[0]?.formatted_address);
    return results[0]?.formatted_address || "Address not found";
  } catch (error) {
    console.error("Error fetching address:", error);
    return "Error fetching address";
  }
};

export const getLatLng = async (address) => {
  console.log("Address provided:", address);
  setKey("AIzaSyDorJcVM6WPoi1QjXo4EFW5Oqft-MlMfvo");

  try {
    const { results } = await fromAddress(address);
    const { lat, lng } = results[0].geometry.location;
    console.log("///////////Lat Lng from Address/////////////");
    console.log(lat, lng);
    return { lat, lng };
  } catch (error) {
    console.error("Error fetching Lat/Lng:", error);
    return null;
  }
};

export const onPageHeadSEO = (title, desc, keywords) => {
  document.title = title;
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", desc);
  document
    .querySelector('meta[name="keywords"]')
    .setAttribute("content", keywords);
};
